const NEGATIVE_GUTTERS_MAP = {
  sm: 'var(--grid-negative-gutter-sm)',
  md: 'var(--grid-negative-gutter-md)',
  lg: 'var(--grid-negative-gutter-lg)',
  xl: 'var(--grid-negative-gutter-xl)',
  xxl: 'var(--grid-negative-gutter-xxl)'
}

export default NEGATIVE_GUTTERS_MAP
